import type { VideoFilterService } from './ports';
import { MediaPipeCanvasVideoFilterService } from './adapters';

let videoFilterServiceInstance: VideoFilterService | null = null;

export function getVideoFilterService(): VideoFilterService {
  if (!videoFilterServiceInstance) {
    videoFilterServiceInstance = new MediaPipeCanvasVideoFilterService();
  }

  return videoFilterServiceInstance;
}

export function __resetVideoFilterContainer(): void {
  videoFilterServiceInstance?.stop();
  videoFilterServiceInstance = null;
}

